import { gql } from '@apollo/client'

const mutationCreateVenueUser = gql(`
  mutation createVenueUser ( $venueName: String! ) {
    createVenueUser (venueName: $venueName) {
      success
      error {
        message
        code
      }
      }
  }`)

export default mutationCreateVenueUser
